"use client";
import { SOLUTIONS_COMP } from "./constants";
import { Box, Stack, Text, Heading, Button, Flex, Divider, Icon } from "@chakra-ui/react";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import Link from "next/link";
import { FiArrowUpRight } from "@onemind-services-llc/react-icons-ng/fi";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { TEXT_VARIANTS } from "@/theme/components/text";

const Solutions = () => {
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();
  const { LeftPanel, RightPanel } = SOLUTIONS_COMP;
  return (
    <Flex direction={{ base: "column", md: "row" }}>
      <Box
        backgroundColor={"primary.200"}
        flex={"0 0 60%"}
        py={{ base: 10, md: 20 }}
        px={{ base: 6, md: 20 }}
        borderRadius={"8px"}
      >
        <Stack spacing={8} width={{ base: "100%", md: "85%" }}>
          <Heading variant={HeadingVariant} color="white">
            {LeftPanel.title}
          </Heading>
          <Box>
            {LeftPanel.content.map((item, index) => (
              <Text key={index} variant={TextVariant} color="white">
                {item}
              </Text>
            ))}
          </Box>
          <Button
            as={Link}
            variant={BUTTON_VARIANTS.SECONDARY}
            href={LeftPanel.button.link}
            width={"fit-content"}
          >
            {LeftPanel.button.label}
          </Button>
        </Stack>
      </Box>
      <Box
        my={{ base: "-4vw", md: "2vw" }}
        mx={{ base: "5vw", md: "5vw" }}
        ml={{ md: "-10%" }}
        backgroundColor={"white"}
        flex={"0 0 50%"}
        borderRadius={"8px"}
        justifyContent={"space-around"}
        boxShadow={"xl"}
        p={{ base: 5, md: 10 }}
      >
        {RightPanel.features.map((item, index) => (
          <Box key={index}>
            <Box>
              <Icon as={item.icon} boxSize={5} mr={2} />
              <Heading variant={HEADING_VARIANTS.SUBTITLE3} as="span">
                {item.title}
              </Heading>{" "}
              :{" "}
              <Text variant={TEXT_VARIANTS.BODY2} as="span" color="text.100">
                {item.content}
              </Text>
            </Box>
            <Button
              as={Link}
              href={item.button.link}
              variant={BUTTON_VARIANTS.LINK}
              color="text.100"
              rightIcon={<FiArrowUpRight />}
              mt={2}
            >
              {item.button.label}
            </Button>
            <Divider my={4} />
          </Box>
        ))}
        <Text variant={TextVariant} color="text.100" fontWeight={600}>
          {LeftPanel.conclusion}
        </Text>
      </Box>
    </Flex>
  );
};

export default Solutions;
